import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import currency from 'currency.js';
import type { JournalSummaryIntervalItem } from 'donor-elf-web/controllers/funds/fund/journals/mock-summaries';

interface ComponentArgs {
  goalAmount: number;
  intervalItems: JournalSummaryIntervalItem[];
}

// used in the journals/summaries page from mock data
export default class JournalSummaryDecisionsMadeMockComponent extends Component<ComponentArgs> {
  @cached
  get decisionsMadeAmount(): number {
    return this.args.intervalItems.reduce(
      (sum: number, item) => currency(sum).add(item.amount).value,
      0,
    );
  }

  get decisionsMadePercent(): number {
    return (this.decisionsMadeAmount * 100) / this.args.goalAmount;
  }
}
